module.exports = __webpack_public_path__ + "static/media/icon_temperature.8859e2eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon_temperature.svg
// module id = 78
// module chunks = 0